/*
 * Quantellia ODIModel
 *
 * Copyright (c) 2016 - 2025 Quantellia LLC
 * 
 *  All Rights Reserved.
 * 
 * NOTICE:  All source code, data, and any other information contained 
 * in this file is, and remains the property of Quantellia LLC.
 * The intellectual and technical concepts contained
 * herein are proprietary to Quantellia LLC and may be covered by
 * U.S. and Foreign Patents, patents in process, and are protected 
 * by trade secret or copyright law. Dissemination of this information 
 * or reproduction of this material is strictly forbidden unless 
 * prior written permission is obtained from Quantellia LLC.
 * 
 * The above notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 *
 */

/**
 *  Represenst a graph in the format used by the Vis.js application.
 */
export class VisModel
{
    #model;

    /**
     * Create a new instance of a VisModel
     */
    constructor()
    {
        this.model = {
                        nodes: [],
                        edges: []
                    };
    }


    /**
     * Add a new edge to the Vis model
     * @param {object} edge Javascript object specifying the edge
     * @returns A reference to the edge object.
     */
    addEdge(edge)
    {
        this.model.edges.push(edge);
        return edge;
    }

    /**
     * Add a new node to the Vis model
     * @param {object} node Javascript object specifying the node
     * @returns A reference to the node object.
     */
    addNode(node)
    {
        this.model.nodes.push(node);
        return node;
    }

    /**
     * Serializes the model as a JSON string
     * @returns A JSON string representing the model.
     */
    toJSON()
    {
        return JSON.stringify(this.model);
    }
}